angular.module('jv.eSig.OfferLetter.controller', [])
    .controller('jv.eSig.OfferLetter.controller', [
        '$scope', '$rootScope', 'TemplateLoader', 'jvCandidatesService', '$localStorage', '$routeParams', '$window','$jobviteUrls','jvHireUrlService',
        function($scope, $rootScope, TemplateLoader, jvCandidatesService, $localStorage, $routeParams, $window,$jobviteUrls,jvHireUrlService) {
            $scope.flags.loading = false;
            //scope.localstorage will hold a map of esigFileEId: companySignerEId
            $scope.localStorage = $localStorage;
            $scope.selectedSigningOrder = null;
            $scope.localStorage.offerLetters = $scope.localStorage.offerLetters || {};
            $scope.esig  = {
                files: []
            };
            //watching when user uploads a file and storing fileEId in esigFileEId
            $scope.$watch('esig',function(fileObject){
                if(!$.isEmptyObject(fileObject.files) ){
                    $scope.showCompanySigner = false;
                    $scope.candidateSignerMissing = false;
                    angular.forEach(fileObject,function(file){
                            angular.forEach(file,function(response){
                                $scope.esigFileEId = response.resourceInfo.eid;
                                if(response && response.validationStatus){
                                    //check candidate signer field missing first as its required
                                    if(response.validationStatus === 'CANDIDATE_SIGNER_FIELD_MISSING'){
                                        $scope.candidateSignerMissing = true;
                                    }
                                    else if(response.validationStatus === 'COMPANY_SIGNER_FIELD_FOUND'){
                                        $scope.showCompanySigner = true;
                                    }
                                }
                            });
                    });
                }else{
                    //removing the only attachment that was uploaded
                    $scope.candidateSignerMissing = false;
                    $scope.showCompanySigner = false;
                }
            },true);

            //This method will associate a company signer with a esig file and store this map in localstorage
            $scope.saveCompanySigner = function(){
                $scope.flags.loading = true;
                $scope.localStorage.offerLetters[$scope.esigFileEId] = $scope.localStorage.offerLetters[$scope.esigFileEId] || {};
                $scope.localStorage.offerLetters[$scope.esigFileEId].users = [];
                $scope.localStorage.offerLetters[$scope.esigFileEId].userObjs = [];

                if (angular.isDefined($scope.selectedSigningOrder))
                 {
                    $scope.localStorage.offerLetters[$scope.esigFileEId].signingOrder = $scope.selectedSigningOrder;
                 }

                if($scope.companySigner){
                    $scope.localStorage.offerLetters[$scope.esigFileEId].users.push($scope.companySigner.EId);
                    $scope.localStorage.offerLetters[$scope.esigFileEId].userObjs.push($scope.companySigner);
                }
                //$scope.localStorage.offerLetters[$scope.esigFileEId] = $scope.companySigner;
                var args = {
                    applicationEId: $routeParams.applicationId,
                    fId: $scope.esigFileEId
                };
                //post to BE
                jvCandidatesService.uploadEsigOfferLetter(args,function(response){
                    $scope.flags.loading = false;
                    if(response && response.data &&  response.data.msgInfo === 200){
                        $window.location.href = jvHireUrlService.getApplicationDetailsUrl($routeParams.applicationId,false,'workflow');
                    }
                });
            };
        }
]);